// Consolidated Accessibility Report Component
// Both /accessibility and /accessibility-conformance-report routes use this component
import AccessibilityConformanceReport from './AccessibilityConformanceReport';

export default AccessibilityConformanceReport;
